export default __webpack_public_path__ + "static/media/return.c055bb63.svg";